const LibIsMobile = () => {
  return /iPhone|iPod|Android|webOS|blackberry|Mobile|midp|cldc|pwa/.test(navigator.userAgent)
}

const LibIsDesktop = () => { return !LibIsMobile() }

export { LibIsDesktop, LibIsMobile }
